import { isEmpty } from '../../../general/isEmpty';
import isEmptyArray from '../../../general/isEmpty/isEmptyArray';
import isEmptyObject from '../../../general/isEmpty/isEmptyObject';
import isObject from '../../../general/isObject';

// ----------------------------------------------------------------------------

function getRowData(data: any[], id: string, obj: Record<string, any>): any[] | object | undefined {
    if (isEmptyArray(data) || isEmpty(id) || isEmptyObject(obj)) {
        return;
    }

    //
    let index = 0;
    const ids = id.split('-');

    // Foreach Ids
    for (const item of ids) {
        // If data is object
        if (isObject(data) && data[obj[index]] != null) {
            data = data[obj[index]][item];
            index++;
        }
        // Is data is array
        else if (Array.isArray(data)) {
            data = data[item];
        }
    }

    return data;
}

// ----------------------------------------------------------------------------

export { getRowData };
